import { render } from "./MainLayout.vue?vue&type=template&id=38ed59d3"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=38ed59d3&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script